<app-kontable
  id="dt_brand"
  title="{{ 'brandList.sectionTitle' | translate }}"
  [columns]="['id', 'code', 'name', 'logo']"
  [titles]="['ID', 'brandList.code', 'brandList.name', 'brandList.logo']"
  [source]="brands"
  [showInfoButton]="true"
  [showRecoverButton]="true"
  [showDetailsButton]="false"
  [showAddButton]="true"
  [showGlobalFilter]="false"
  (onAdd)="showAddOrEditDialog($event)"
  (onEdit)="showAddOrEditDialog($event)"
  (onRemove)="delete($event)"
  (onRecover)="recoverBrand($event)"
>
</app-kontable>

<p-dialog
        *ngIf="srvBrand.brandEditing"
        [(visible)]="srvBrand.brandEditing"
        [modal]="true"
        header="{{modalTitle}}"
        [minWidth]="500"
        [draggable]="false"
        [resizable]="false"
        (onHide)="closeDialog()">
    <app-brand-form
            (brandAdded)="brandAdded($event)"
            (brandUpdated)="brandUpdated($event)"
            [dialogBoxBrand]="srvBrand.brandEditing"
    ></app-brand-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/brand/brand.component.html